import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbDropdownConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { UserService } from 'src/app/services/user/user.service';
import { ImportWizardComponent } from '../import-wizard/import-wizard.component';
import { DistributorsDataService } from 'src/app/services/distributorsData/distributorsData.service';
import { LogoUpdateService } from 'src/app/services/logo-update.service';
import { FeatureBellService } from 'src/app/services/feature-bell/feature-bell.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {
    @ViewChild('switchThemeModalContent') switchThemeModalContent: any;
    @Input() logoUrl?: string;
    public iconOnlyToggled = false;
    public sidebarToggled = false;

    userName$ = new BehaviorSubject<string | undefined>(undefined);
    updateEmployee$ = new BehaviorSubject<string | undefined>(undefined);
    isAdmin = false;
    isCustomer = false;
    isManufacturing = false;
    private readonly helpFeatureId = 'help-page-2026';
    

  constructor(
      private _authorizeService: AuthorizeService,
      private _userService: UserService,
      private router: Router,
      private _distributorService: DistributorsDataService,
      private logoUpdateService: LogoUpdateService,
      private featureBellService: FeatureBellService,
      private modalService: NgbModal,
        config: NgbDropdownConfig) {
        config.placement = 'bottom-right';
    }
    private _EmployeeId?: string
    private _UserId?: string
    showBell$ = this.featureBellService.watch(this.helpFeatureId);

  ngOnInit() {
      this._authorizeService.user$.subscribe(user => {
        if (user != null) {
          //DBW The ?? notation makes sure we have a value, either a real value or blank.
          let uName = user?.username
          if (user?.postfix !== undefined && user?.postfix.length > 0)
            uName = uName + "@" + user?.postfix;
          this.userName$.next(uName);
          this.setThemeColors(user?.theme ?? "dark");

          this._EmployeeId = user?.employeeId?.toString();
          this._UserId = user?.userId.toString();

          if (user?.roleName?.includes("Admin"))
            this.isAdmin = true;
          if (user?.roleName?.includes("Customer")) {
            this.isCustomer = true;
            }
        if (user?.roleName?.includes('Manufacturing') && !user?.roleName?.includes('ManufacturingAdmin'))
            this.isManufacturing = true;

          localStorage.setItem('theme', user?.theme ?? "dark"); // or in this case, the default is "dark"
          localStorage.setItem('distid', user?.distributorId?.toString() ?? "");
          localStorage.setItem('distname', user?.distributorName ?? "");
        }
    });

    // Load logo on initial page load
    const id = Number(localStorage.getItem('distid'));
    if (id) {
      this.loadLogo(id);
    }

    // When user switches distributors
    this.logoUpdateService.distributorChanged$.subscribe(id => {
      this.loadLogo(id);
    });

    // When logo is uploaded or deleted
    this.logoUpdateService.logoUpdated$.subscribe(url => {
      if (!url) {
        this.logoUrl = undefined;
        return;
      }
      this.logoUrl = `${url}?v=${Date.now()}`;
    });
  }


  private loadLogo(id: number) {
  this._distributorService.getDistributor$(id).subscribe(d => {
    if (!d.logoUrl) {
      this.logoUrl = undefined;
      return;
    }
    this.logoUrl = `${d.logoUrl}?v=${Date.now()}`;
  });
}

  openImportWizard() {
    this.modalService.open(ImportWizardComponent, {
      windowClass: 'import-wizard-modal  modal-lg',
      backdrop: 'static',
      keyboard: false
    });

}


navigateToHelp(): void {
    this.router.navigate(['/dashboard/help']);
}

  // toggle sidebar in small devices
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas')?.classList.toggle('active');
  }
  

  // toggle sidebar
  toggleSidebar() {
    let body = document.querySelector('body');
    if((!body?.classList.contains('sidebar-toggle-display')) && (!body?.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if(this.iconOnlyToggled) {
        body?.classList.add('sidebar-icon-only');
      } else {
        body?.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if(this.sidebarToggled) {
        body?.classList.add('sidebar-hidden');
      } else {
        body?.classList.remove('sidebar-hidden');
      }
    }
  }

  // toggle right sidebar
  toggleRightSidebar() {
    document.querySelector('#right-sidebar')?.classList.toggle('open');
    }

    // toggle theme
    toggleTheme() {
      this.openSwitchThemeModal(this.switchThemeModalContent);
    }

    openSwitchThemeModal(switchThemeModalContent: any) {
        this.modalService.open(switchThemeModalContent);
    }

    confirmSwitchTheme() {
        let theme: string = "";

        //DBW If we ever support more themes, then we need to handle that in this code
        if (localStorage.getItem('theme') == "dark") {
            theme = "light"; // Switch dark to "light"
        }
        else if (localStorage.getItem('theme') == "light") {
          theme = "dark";  // Swith light to dark
        }
        else {
            theme = "dark"; // Switch anything else to "dark"
        }

        this.setThemeColors(theme); // Theme color change happens here

        // Write the change out to the database here. This way whatever the user chose last will now be their default
        if (this._UserId != undefined) {
          this._userService.updateUserTheme$(this._UserId, theme).subscribe(result => { });
        }

        //update the local storage
        localStorage.setItem('theme', theme);

        this.modalService.dismissAll();
        window.location.reload();
    }

    cancelSwitchTheme() {
      this.modalService.dismissAll();
    }

    setThemeColors(theme: string|undefined) {
        if (theme == undefined) {
            theme = "dark";  //Setting dark as default when none selected
        }
        if (theme === 'dark') {
            // Set Dark Theme
            //CONTENT BACKGROUND
            document.documentElement.style.setProperty(`--theme-content-bg`, '#000000');
            //TEXT
            document.documentElement.style.setProperty(`--theme-body-color`, '#FFFFFF');
            document.documentElement.style.setProperty(`--theme-text-muted`, '#6c7293');
            //CARD
            document.documentElement.style.setProperty(`--theme-card-bg`, '#191c24');
            document.documentElement.style.setProperty(`--theme-card-description-color`, '#bfbfbf');
            document.documentElement.style.setProperty(`--theme-card-title-color`, '#FFFFFF');
            //DROP DOWN
            document.documentElement.style.setProperty(`--theme-dropdown-border-color`, '#2c2e33');
            document.documentElement.style.setProperty(`--theme-dropdown-divider-bg`, '#2c2e33');
            document.documentElement.style.setProperty(`--theme-dropdown-link-color`, '#FFFFFF');
            document.documentElement.style.setProperty(`--theme-dropdown-header-color`, '#FFFFFF');
            document.documentElement.style.setProperty(`--theme-dropdown-bg`, '#191c24');
            document.documentElement.style.setProperty(`--theme-dropdown-color`, '#FFFFFF');
            document.documentElement.style.setProperty(`--theme-dropdown-hover`, '#5e6065');
            //NAV BAR
            document.documentElement.style.setProperty(`--theme-navbar-bg`, '#191c24');
            //SIDE BAR
            document.documentElement.style.setProperty(`--theme-sidebar-bg`, '#191c24');
            document.documentElement.style.setProperty(`--theme-sidebar-menu-active-bg`, '#181b23');
            document.documentElement.style.setProperty(`--theme-sidebar-active-color`, '#FFFFFF');  // Selected Color
            document.documentElement.style.setProperty(`--theme-sidebar-menu-color`, '#AAAAAA'); // Unselected default color
            document.documentElement.style.setProperty(`--theme-sidebar-menu-hover-color`, '#FF00FF'); // hover color MAGENTA

            //Customer Accordion Title
            document.getElementById('accord')?.setAttribute('class', 'accordionTitleDark');

            //AG Grid
            if (document.getElementsByClassName('ag-theme-alpine')[0])
                document.getElementsByClassName('ag-theme-alpine')[0].setAttribute('class', 'ag-theme-alpine-dark');
        }
        //else if (theme === "light") {
        else {
            // Set Light Theme
            //CONTENT BACKGROUND
            document.documentElement.style.setProperty(`--theme-content-bg`, '#F6F6F2');  // Main Background color Light Gray
            //document.documentElement.style.setProperty(`--theme-content-bg`, '#F6F6F2');
            document.documentElement.style.setProperty(`--theme-content-bg`, '#CACAC8');

            //TEXT
            document.documentElement.style.setProperty(`--theme-body-color`, '#000000');  // Main Text color
            document.documentElement.style.setProperty(`--theme-text-muted`, '#6B6D7A');  // Main Text color muted
            //CARD
            //document.documentElement.style.setProperty(`--theme-card-bg`, '#91C2E8');  // Card Background Color Currently same for Top Navbar and Sidebar
            //document.documentElement.style.setProperty(`--theme-card-bg`, '#91C2E8');
            document.documentElement.style.setProperty(`--theme-card-bg`, '#BFBFBD');

            document.documentElement.style.setProperty(`--theme-card-description-color`, '#bfbfbf');
            document.documentElement.style.setProperty(`--theme-card-title-color`, '#F6F6F2');
            //DROP DOWN
            document.documentElement.style.setProperty(`--theme-dropdown-border-color`, '#6B6D7A');
            document.documentElement.style.setProperty(`--theme-dropdown-divider-bg`, '#6B6D7A');
            document.documentElement.style.setProperty(`--theme-dropdown-link-color`, '#6B6D7A');
            document.documentElement.style.setProperty(`--theme-dropdown-header-color`, '#FFFFFF');  // Not Used????
            document.documentElement.style.setProperty(`--theme-dropdown-bg`, '#F6F6F2');  // Normal background
            document.documentElement.style.setProperty(`--theme-dropdown-hover`, '#5e6065'); // Hover background
            document.documentElement.style.setProperty(`--theme-dropdown-color`, '#000000'); //Non link Text
            //NAV BAR
            //document.documentElement.style.setProperty(`--theme-navbar-bg`, '#91C2E8');  // Top Navbar Background Color Currently same for Card and Sidebar
            //document.documentElement.style.setProperty(`--theme-navbar-bg`, '#91C2E8');
            document.documentElement.style.setProperty(`--theme-navbar-bg`, '#BFBFBD');
            //SIDE BAR
            //document.documentElement.style.setProperty(`--theme-sidebar-bg`, '#91C2E8');  // Sidebar Background Color Currently same for Card and Top Navbar
            //document.documentElement.style.setProperty(`--theme-sidebar-bg`, '#91C2E8');
            document.documentElement.style.setProperty(`--theme-sidebar-bg`, '#BFBFBD');
            document.documentElement.style.setProperty(`--theme-sidebar-menu-active-bg`, '#e7e4dc');
            document.documentElement.style.setProperty(`--theme-sidebar-active-color`, '#000000'); // Selected Color
            document.documentElement.style.setProperty(`--theme-sidebar-menu-color`, '#444444'); // Unselected default color
            document.documentElement.style.setProperty(`--theme-sidebar-menu-hover-color`, '#00FF00'); // hover color GREEN

            //Customer Accordion Title
            document.getElementById('accord')?.setAttribute('class', 'accordionTitleLight');

            //AG Grid
            if (document.getElementsByClassName('ag-theme-alpine-dark')[0])
                document.getElementsByClassName('ag-theme-alpine-dark')[0].setAttribute('class', 'ag-theme-alpine');
        }

    }
    //flexSwitchTheme

    onNavigate() {
      window.open("http://onetankdashboard.nascorp-skytracker.com/", "_blank");
    }

}
